import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const Testimonials = () => {
    const { t } = useLang();
    return (
        <section
            id="testimonials"
            data-testid="testimonials-section"
            className="relative py-14 sm:py-20"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="max-w-2xl mb-14"
                >
                    <span className="font-display text-[var(--primary)] text-sm tracking-[0.3em]">
                        {t.testimonials.eyebrow}
                    </span>
                    <h2 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight">
                        {t.testimonials.h2Top}
                        <br />
                        <span className="text-gradient-orange">
                            {t.testimonials.h2Bottom}
                        </span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {t.testimonials.items.map((tt, i) => (
                        <motion.div
                            key={i}
                            data-testid={`testimonial-${i}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                            className="card-dark rounded-2xl p-7 sm:p-8 relative group flex flex-col"
                        >
                            <Quote className="absolute top-6 start-6 w-10 h-10 text-[var(--primary)]/20 group-hover:text-[var(--primary)]/50 transition-colors rotate-180" />
                            <div className="flex gap-1 mb-4">
                                {Array.from({ length: 5 }).map((_, idx) => (
                                    <Star
                                        key={idx}
                                        className="w-4 h-4 fill-[var(--primary)] text-[var(--primary)]"
                                    />
                                ))}
                            </div>
                            <p className="text-lg text-neutral-200 leading-relaxed flex-1">
                                "{tt.quote}"
                            </p>
                            <div className="mt-6 pt-5 border-t border-white/5">
                                <div className="font-bold text-white">{tt.name}</div>
                                <div className="text-sm text-[var(--primary)] mt-1">
                                    {tt.role}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
